import { Component, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TravellerAssessment, AssessmentStatus } from '@awp/models';

@Component({
  selector: 'ap-assessment-cover',
  templateUrl: './assessment-cover.component.html',
  host: {
    'class': 'ap-assessment-cover'
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssessmentCoverComponent {

  AssessmentStatus = AssessmentStatus;
  showContent = false;
  displayFields = [
    {
      fieldName: 'id',
      displayLabel: 'Assessment number',
      order: 1
    },
    {
      fieldName: 'conditions',
      displayLabel: 'Assessed conditions',
      order: 2
    },
    {
      fieldName: 'outcome',
      displayLabel: 'Assessment outcome',
      order: 3
    }
  ];

  @Input() traveller: TravellerAssessment;
  @Input() startAssessmentLabel: string;
  @Output() startAssessment = new EventEmitter<TravellerAssessment>();

}
